import Layout from "@/layout/index.vue";

export default [
  // 慢病险管理
  {
    path: "/rxa",
    name: "rxa",
    component: Layout,
    redirect: "/rxa/live-clue-list",
    meta: {
      title: "慢病险管理",
    },
    children: [
      {
        path: "/rxa/clue-enter",
        name: "rxaClueEnter",
        component: () => import("@/views/rxa/pages/clue-enter/index.vue"),
        meta: {
          title: "线索录入",
          newPage: true,
          noCache: true
        },
      },
      {
        path: "/rxa/qywx-scheduling",
        name: "qywxScheduling",
        component: () => import("@/views/rxa/pages/qywx-scheduling/index.vue"),
        meta: {
            title: "企微排班管理",
            newPage: true,
            noCache: true
        },
      },
      {
        path: "/rxa/live-clue-list",
        name: "rxaLiveClueList",
        component: () => import("@/views/rxa/pages/live-clue-list/index.vue"),
        meta: {
          title: "线索管理",
          newPage: true,
        },
      },
      {
        path: "/rxa/seat-follow",
        name: "seatFollow",
        component: () => import("@/views/rxa/pages/seat-follow/index.vue"),
        meta: {
          title: "坐席跟进管理",
          newPage: true,
        },
      },
      {
        path: "/rxa/material-report",
        name: "rxaMaterialReport",
        component: () => import("@/views/rxa/pages/material-report/index.vue"),
        meta: {
            title: "素材产出管理",
            newPage: true
        },
      },
    ],
  },
]
